import Vue from 'vue'
import { fetch } from 'whatwg-fetch'
// import { Toast } from 'vant'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'
import { getToken, removeToken } from '@/utils/auth'
import { ApolloLink } from 'apollo-link'
import Raven from 'raven-js'

Vue.use(VueApollo)

const httpEndpoint = process.env.VUE_APP_API + '/graphql' || 'http://localhost:3000/graphql'

// 创建 HTTP 连接 (绝对路径)
const httpLink = new HttpLink({
  uri: httpEndpoint,
  fetch: fetch
})

// 错误处理
const errLink = onError(({ operation, graphQLErrors, networkError }) => {
  let info = {
    operationName: operation.operationName,
    variables: operation.variables
  }
  Raven.setUserContext({
    token: getToken()
  })
  if (graphQLErrors) {
    Object.assign(info, {
      type: '接口报错'
    })
    graphQLErrors.map(({ extensions, message }, index) => {
      Object.assign(info, {
        [`code${index}`]: extensions.code,
        [`message${index}`]: message
      })
      if (extensions.code === 'AUTHENTICATION_ERROR') {
        removeToken()
        window.location.replace(location.href)
      }
    })
    Raven.captureException(info)
  }
  if (networkError) {
    Object.assign(info, {
      type: '网络错误',
      statusCode: networkError.statusCode
    })
    Raven.captureException(info)
    switch (networkError.statusCode) {
      case 401:
        removeToken()
        window.location.reload()
        break
      default:
    }
  }
})

// 添加授权请求头 (https://www.apollographql.com/docs/react/recipes/authentication/)
const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'API-TOKEN': getToken() || ''
    }
  }
})

// 创建 apollo 客户端
const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, errLink, httpLink]),
  cache: new InMemoryCache(), // 缓存
  connectToDevTools: true
})

// 创建 Apollo provider 客户端实例方法
export function createProvider() {
  return new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $loadingKey: 'loading'
    }
  })
}
